<div class="request_dialog">
  <div class="header_confirm">Do You Want to Grant Access Permissions?</div>
  <div class="dialog_header"></div>
  <div class="dialog_subheader"></div>
  <div class="permission_required">
    <!-- <div style="font-size: 30px;font-family: var(--font);font-weight: 500;margin-bottom: 20px;letter-spacing: 1px;
word-spacing: 1px;">Permission Details</div> -->

    <div class="permission_type" style="margin: 10px 0px;">
      <mat-radio-group aria-label="Select an option" [formControl]="PermissionDetailsInfo" >
        <mat-radio-button value="Read" style="margin-right: 15px;font-family: var(--font);letter-spacing: 1px;
word-spacing: 1px;">Read</mat-radio-button>
        <mat-radio-button value="Read & Write" style="font-family: var(--font);letter-spacing: 1px;
word-spacing: 1px;">Read & Write</mat-radio-button>
      </mat-radio-group>
    </div>
    <p style="font-family: var(--font);font-size: 17px;margin:20px 0px;letter-spacing: 1px;
word-spacing: 1px;">Do you want to approve or decline this request?</p>
    <div>
      <button class="permission_button" (click)="acceptRequest()">Accept</button>
      <button class="permission_button" (click)="declineRequest()">Decline</button>
      <button class="permission_button" (click)="closeDialog()">Cancel</button>
    </div>
  </div>